import { render, staticRenderFns } from "./ParentFicheSinistre.vue?vue&type=template&id=3b4cd658&"
import script from "./ParentFicheSinistre.vue?vue&type=script&lang=js&"
export * from "./ParentFicheSinistre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports